import { Component, Input, OnInit } from '@angular/core';
import { BrandEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-incomplete-order',
  templateUrl: './incomplete-order.component.html',
  styleUrls: ['./incomplete-order.component.scss']
})
export class IncompleteOrderComponent implements OnInit {

  @Input() brandId: BrandEnum;
  @Input() isRegFlow: boolean;
  checkoutUrl: string;

  constructor() { }

  ngOnInit(): void {
    this.checkoutUrl = this.isRegFlow ? '/registration/order-summary' : '/checkout/address';
  }

  public get BrandEnum() {
    return BrandEnum;
  }

}
